// Frontend environment helper.
// VITE_ENV is set in frontend/.env (default "develop"). In production deploys
// (Vercel etc.) set it to "production" to hide dev-only UI like the model
// selector dropdown and the Memorize tab.

const ENV = (import.meta.env.VITE_ENV ?? 'develop').toLowerCase();

export const isDev: boolean = ENV !== 'production';
export const isProd: boolean = ENV === 'production';
